import Vue from 'vue'
import Vant from 'vant';
import 'vant/lib/index.css';
import App from './App.vue';
import router from './router';
import store from './store';
import * as filters from '@/filters';
import Vconsole from 'vconsole';
import './permission';
import '@/assets/css/iconfont.less';
import VueClipboard from 'vue-clipboard2';
import axios from "axios";
if (process.env.NODE_ENV === 'test') {
	new Vconsole();
}
// head[0].children.push({
// 	name:'description',
// 	content:'你好？'
// })
// head[0].children[]
router.beforeResolve((to, from, next) => {
	if(to.path==='/proResearch'){
		document.querySelector('meta[name="description"]').setAttribute('content', "认真填写，绝对保密！");
	}
	console.log(to)
	next();
});


Vue.use(VueClipboard)
Vue.use(Vant);
Object.keys(filters).forEach(key => {
	Vue.filter(key, filters[key]);
})
Vue.config.productionTip = false
Vue.prototype.$axios = axios;
new Vue({
	router,
	store,
	render: h => h(App)
}).$mount('#app')
